import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=c240af62&lang=pug&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=c240af62&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c240af62')) {
      api.createRecord('c240af62', component.options)
    } else {
      api.reload('c240af62', component.options)
    }
    module.hot.accept("./Popover.vue?vue&type=template&id=c240af62&lang=pug&", function () {
      api.rerender('c240af62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/Popover.vue"
export default component.exports